export default "__VITE_ASSET__vpTq68RL__"